import { DeviceType } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const deviceTypeDictionary = createSimpleDictionary([
    { id: DeviceType.PC, name: 'dictionaries.deviceType.pc' },
    { id: DeviceType.Mobile, name: 'dictionaries.deviceType.mobile' },
]);
